/**
 * @author Ariel
 * @description 管理权限设置
 * @Date 2023/04/20
 */
let componentName = 'managerPermissionsSetting';

const columns = [
  {
    name: 'id',
    formItem: {
      type: 'hidden'
    }
  },
  {
    name: 'delFlag',
    formItem: {
      type: 'hidden'
    }
  },
  {
    title: '品牌名称',
    name: 'brandName',
    searchItem: {
      type: 'select'
    },
    tableItem: {},
    formItem: {
      type: 'select',
      rules: [
        {
          required: true,
        },
      ]
    },
    dict: [
      {code: '售后', codeName: '售后'},
      {code: '名爵', codeName: '名爵'},
      {code: '荣威', codeName: '荣威'},
    ]
  },
  {
    title: '岗位名称',
    name: 'positionName',
    searchItem: {},
    tableItem: {},
    formItem: {
      maxlength: 100,
      rules: [
        {
          required: true,
        },
      ]
    }
  },
  {
    title: '岗位Id',
    name: 'positionId',
    tableItem: {},
  },
  {
    title: '角色名称',
    name: 'roleName',
    searchItem: {},
    tableItem: {},
    formItem: {
      maxlength: 100,
      rules: [
        {
          required: true,
        },
      ]
    }
  },
  {
    title: '角色Id',
    name: 'roleId',
    tableItem: {},
  },
  {
    title: '管理组织名称',
    name: 'managerOrgName',
    searchItem: {},
    tableItem: {},
    formItem: {
      maxlength: 50,
      rules: [
        {
          required: true,
        },
      ]
    }
  },
  {
    title: '管理组织Id',
    name: 'managerOrgId',
    tableItem: {},
  },
  {
    title: '管理岗位分类名称',
    name: 'positionCategoryName',
    searchItem: {},
    tableItem: {},
    formItem: {
      maxlength: 50,
      rules: [
        {
          required: true,
        },
      ]
    }
  },
  {
    title: '管理岗位分类id',
    name: 'positionCategoryId',
    tableItem: {},
  },
];

const templateConfig = {
  mainProps: {},
  content: {
    name: 'WizTableList',
    params: {
      columns,
      searchBarProps:{
        buttonSort: ['add','delete','batchUpdateSetting'],
        collapse: false,
        buttons: [
          {
            key: 'batchUpdateSetting',
            custom: true,
            params: { icon: 'sync', children: '更新信息'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: "batchUpdateSetting",
                apiParams: {}
              },
              formatParams: (rows, record, filter) => {
                return { ...filter };
              }
            }
          }
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: 'id',
        selectType: 'checkbox',
        isScroll: true,
        bordered: false,
        paging: false,
        loading: false
      },
      rowOperateSort: ['update'],
      rowOperateView: [],
      rowOperateProps: {
        width: 80,
        fixed: 'right',
      },
      commonOperate: {
        add: true,
        delete: true,
        edit: true
      }
    }
  }
}

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  add: {
    path: `${componentName}/add`,
    payload: {
      key: `${componentName}@add`,
      apiParams: {}
    }
  },
  update: {
    path: `${componentName}/update`,
    payload: {
      key: `${componentName}@update`,
      apiParams: {}
    }
  },
  delete: {
    path: `${componentName}/delete`,
    payload: {
      key: `${componentName}@delete`,
      apiParams: {}
    }
  },
  batchUpdateSetting: {
    path: `${componentName}/batchUpdateSetting`,
    payload: {
      key: `${componentName}@batchUpdateSetting`,
      apiParams: {}
    }
  }
};

let reduxTemplateConfig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export {reduxTemplateConfig, templateConfig};
